import React, { useState } from 'react';

import { USER_ROLES } from 'constants/index';
import { selectRoomId } from 'client/redux/room/selectors';
import { useAppSelector, useResponsive } from 'client/hooks';
import { selectUserRoomRole } from 'client/redux/client/selectors';
import { selectActiveSpeakers, selectListenersAllowedToSpeak } from 'client/redux/pubnub/selectors';

import ListenerIcon from '../ListenerIcon';
import Icon, { IconType } from '../../Icon';
import ConnectionControls from '../../ConnectionControls';
import WaiterOnClickPopup from '../../Popups/WaiterOnClickPopup';

import css from './WaiterSpeakContainer.module.scss';

type Props = {
  isInlineControls?: boolean;
};

const WaiterSpeakContainer: React.FC<Props> = (props) => {
  const { isInlineControls = false } = props;
  const [popupActivity, setPopupActivity] = useState<boolean>(false);
  const listOfAllowedToSpeak = useAppSelector(selectListenersAllowedToSpeak);
  const activeSpeakers = useAppSelector(selectActiveSpeakers);
  const roomId = useAppSelector(selectRoomId);
  const userRole = useAppSelector((state) => selectUserRoomRole(state, roomId));
  const [isMobile] = useResponsive('MOBILE');
  const isUserListener = false;
  const pending = false;
  const microphoneType: IconType = pending ? 'black_microphone' : 'red_microphone';

  const onControlPopUpOpen = () => {
    if (userRole === USER_ROLES.ADMIN || userRole === USER_ROLES.HOST) {
      setPopupActivity(true);
    }
  };

  const onControlPopUpClose = () => {
    setPopupActivity(false);
  };

  if (listOfAllowedToSpeak.length === 0) {
    return null;
  }

  return (
    <div className={css.container} onClick={onControlPopUpOpen}>
      <ListenerIcon
        name={listOfAllowedToSpeak[0].name}
        isSpeaking={activeSpeakers.includes(listOfAllowedToSpeak[0].id)}
        isAllowedToSpeak
        pending={pending}
      />
      {(userRole === 'admin' || userRole === 'host') && isInlineControls ? (
        <ConnectionControls onSelectAction={onControlPopUpClose} isAllowedToSpeak listener={listOfAllowedToSpeak[0]} />
      ) : (
        <div className={css.micro}>
          <div>
            {pending ? !isUserListener && <span>מיקרופון לא פעיל</span> : isMobile && <span>מיקרופון פעיל</span>}
          </div>
          <Icon type={microphoneType} />
        </div>
      )}
      {!isInlineControls && popupActivity && (
        <WaiterOnClickPopup listenerData={listOfAllowedToSpeak[0]} isAllowedToSpeak onClose={onControlPopUpClose} />
      )}
    </div>
  );
};

export default WaiterSpeakContainer;
